import React from 'react';
import { ExternalLink } from '../../../../../global/components/external-link-modal';

interface Props {
    brandImage: string;
    brandImageAltText: string;
    bannerImage: string;
    bannerImageUrl: string;
    bannerImageAltText: string;
    userGreeting: string;
    userFullName: string;
    userRole: string;
}
export function PortalLandingBanner(props: Props) {
    const { brandImage, brandImageAltText, bannerImage, bannerImageUrl, bannerImageAltText, userGreeting, userFullName, userRole } = props;

    function Brand() {
        if (brandImage) {
            return (
                <div className='dashboard-header-logo'><img title={brandImageAltText} alt={brandImageAltText} src={brandImage} /></div>
            );
        }

        return null;
    }

    function BannerImage() {
        return (<img className='dashboard-header-banner-image' title={bannerImageAltText} alt={bannerImageAltText} src={bannerImage} />);
    }

    function Banner() {
        if (bannerImage && bannerImageUrl) {
            return (
                <ExternalLink
                    linkUrl={bannerImageUrl}
                    linkText={<BannerImage />} />
            );
        }

        if (bannerImage) {
            return (<BannerImage />);
        }

        return null;
    }

    function UserView() {
        if (!userGreeting && !userFullName && !userRole) return null;

        return (
            <div>
                <p>{userGreeting}</p>
                <p className='h2-styled'>{userFullName}</p>
                { (userRole) && <p className='input-caption'>{userRole}</p>}
            </div>);
    }

    if (!bannerImage && !brandImage) return null;

    return (
        <div className='dashboard-header'>
            <div className='dashboard-header-main'>
                <Brand />
                <div className='dashboard-header-banner'><Banner /></div>
            </div>
            <div className='dashboard-header-greeting'>
                <UserView />
            </div>
        </div>
    );
}